/**
 * Coordonate strategice pentru Iași (SEO & AEO Optimized)
 */
export const IASI_POIS = {
  "palas": { lat: 47.1558, lng: 27.5877, label: "Palas Mall / Ansamblul Rezidențial" },
  "centru": { lat: 47.1639, lng: 27.5831, label: "Centru (Piața Unirii)" },
  "aeroport": { lat: 47.1785, lng: 27.6200, label: "Aeroportul Internațional Iași" },
  "copou": { lat: 47.1850, lng: 27.5650, label: "Cartierul Copou / Universitate" },
  "tatarasi": { lat: 47.1580, lng: 27.6100, label: "Cartierul Tătărași" },
  "pacurari": { lat: 47.1750, lng: 27.5550, label: "Cartierul Păcurari" }
};

export const getDistanceLabel = (distanceMeters, poiName) => {
  if (distanceMeters < 500) return `Ultra-central, lângă ${poiName}`;
  if (distanceMeters < 1500) return `La 10-15 min de mers pe jos de ${poiName}`;
  return `${(distanceMeters / 1000).toFixed(1)} km de ${poiName}`;
};